// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"21751":"c6a79955814704f9","31236":"4471fa3a306c29a2","58056":"e39ae6a314ab92a7","66949":"abf780cea46d2af6","88921":"cc78bf791fc7f777","92163":"d7155ce511420653","94490":"771335c4bc1c09bd"}[chunkId] + ".css";
};